<template>
    <div>
        <base-header class="pb-6" type="">
            <b-row class="align-items-center py-4">
            <b-col lg="12" cols="12">
                <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                <route-breadcrumb/>
                </nav>
            </b-col>
            </b-row>
      </base-header>
        <b-container fluid class="mt--6">
            <div>
                <loading :active="loadCounter > 0"
                    color= '#007bff'
                    :width= '128'
                    :height= '128'
                    loader='dots'
                    :can-cancel="true"
                    :is-full-page="true">
                    </loading>
                </div>
                <b-card>
                    <div slot="header" class="mb-0">
                        <h3>{{language_terms['QUICK_SEARCH']}}</h3>
                    </div>
                    <b-row>
                        <b-col cols="11">
                            <base-input :label="language_terms['QUICK_FILTER']" v-model="filter.keyword" v-on:keyup.enter="clickOnSearch"></base-input>
                        </b-col>
                        <b-col md="2" v-if="0">
                            <base-input :label="language_terms['DATE_FROM']" >
                                <flat-picker
                                    slot-scope="{ focus, blur }"
                                    @on-open="focus"
                                    @on-close="blur"
                                    style="background-color: white"
                                    class="form-control datepicker"
                                    v-model="filter.date_from">
                                </flat-picker>
                            </base-input>
                        </b-col>
                        <b-col md="2" v-if="0">
                            <base-input :label="language_terms['DATE_TO']" >
                                <flat-picker
                                    slot-scope="{ focus, blur }"
                                    @on-open="focus"
                                    @on-close="blur"
                                    style="background-color: white"
                                    class="form-control datepicker"
                                    v-model="filter.date_to">
                                </flat-picker>
                            </base-input>
                        </b-col>
                        <!-- <div>selectedrow{{this.selectedRow}}}</div>
                        <div>{{this.schedules }}</div> -->
                        <b-col cols="1" class="mt-4">
                              <base-button type="primary" @click="clickOnSearch" class="mt-2"><i class="fa fa-search"></i></base-button>
                          </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" v-if="items.length > 0">
                            <v-client-table v-if="items.length > 0" v-model="items" :columns="tableColumns" :options="tableOptions" @row-click="onClickProduct">
                            </v-client-table>
                        </b-col>

                        <!-- <b-col cols="12" v-if="0">
                            <PaginatedTables :myColumns="tableColumns" :tableData="items"
                            :cardTitle="language_terms['SEARCH_RESULTS']" v-if="items.length > 0" v-on:showDetails="onClickProduct"/>
                        </b-col> -->
                    </b-row>
                </b-card>
                <b-modal v-model="rowDetailsModal" :header-bg-variant="headerBgVariant" :header-text-variant="headerTextVariant" size="xl" centered class="my-modal" ok-only>
                    <template #modal-title>
                        <span style="color: white">{{language_terms['PRODUCT'] + ' ' + language_terms['SCHEDULES'] + ' - ' + schedules.product_code}}</span>
                    </template>
                    <b-row v-if="schedules.gits.length > 0">
                        <b-col lg="12" class="mb-3">
                            <h3>GIT</h3>
                        </b-col>
                        <b-col lg="12" class="mb-3">
                            <div class="table-responsive">
                                <v-client-table v-model="schedules.gits" :columns="gitColumns" :options="tableOptions" @row-click="onGITRowClick">
                                </v-client-table>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-if="schedules.reserved.length > 0">
                        <b-col md="12" class="mb-3">
                            <h3>Reserved</h3>
                        </b-col>
                        <b-col md="12" class="mb-3">
                            <div class="table-responsive">
                                <v-client-table v-model="schedules.reserved" :columns="reservedColumns" :options="tableOptions" @row-click="onReservedRowClick">
                                </v-client-table>
                            </div>
                        </b-col>
                    </b-row>
                </b-modal>
        </b-container>
    </div>
</template>

<script>
import { mapState } from 'vuex';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Select, Option } from "element-ui";

import PaginatedTables from '@/views/Tables/PaginatedTables'
import axios from "axios";
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from "../../global";

export default {
    computed:{
        ...mapState({
            language_terms:(state)=>state.languages.language_terms,
            items: (state) => state.stockcards.inventory,
            item_details: (state) => state.stockcards.inventory_details,
            filter_data: (state) => state.stockcards.filter_inventory
        })
    },
    components: {
    Loading,
    flatPicker,
    [Select.name]: Select,
    [Option.name]: Option,
    PaginatedTables
  },
  data()
  {
      return{
        gitColumns:['vendor_name', 'po', 'po_date', 'eta_date_yyww', 'qty', 'request_by'],
        reservedColumns:['date', 'document_code', 'customer_name', 'qty', 'salesperson_name'],
        tableColumns:['product_code', 'product_name','uom', 'onhand_qty', 'git_qty', 'reserved_qty', 'available_qty', 'moq','avg_monthly_consumption_qty','sale_list_price', 'id'],
        tableOptions:{perPage:1000, perPageValues:[],stickyHeader:false, stickyHeaderColor:'#ffffff', stickyHeaderBackground:'#292F4C',hiddenColumns:['id'],filterable:false},
        loadCounter:0,
        headerBgVariant: "primary",
        headerTextVariant: "light",
        rowDetailsModal:false,
        schedules:{gits:[], reserved:[]},
        selectedRow:{},
        filter:{
            keyword:"",
            date_from:'',
            date_to:''
        },
      }
  },
  watch:{
     language_terms: {
          handler(val){
              this.updateTableLang()
          }
        },
    },
  methods:{
    async onReservedRowClick(row)
    {
        let url = '/sales/sales-quotation/' + encodeURIComponent(row.row.document_code)
        window.open(url , '_blank');
    },
    async onGITRowClick(row)
    {
        let url = '/purchase/purchase-order/' + encodeURIComponent(row.row.po)
        window.open(url , '_blank');
    },
    updateTableLang()
    {
        for(let i=0; i < this.tableColumns.length;i++)
        {
            let key = this.tableColumns[i].key
            this.tableColumns[i].label = this.language_terms[key]
        }

        for(let i=0; i < this.itemFields.length;i++)
        {
            let key = this.itemFields[i].key
            this.itemFields[i].label = this.language_terms[key]
        }
    },
    async clickOnSearch()
    {
        this.loadCounter++
        await this.$store.dispatch("stockcards/quickSearchInventory", this.filter);
        this.loadCounter--
    },
    async cellClicked(row) {
      alert('x')
        console.log('Cell clicked', row);
    },
    async handleColumnClick(column, row)
    {
        alert('x')
        alert(column)
    },
    async onClickProduct(event)
    {
        if(event.row && !event.event.altKey)
        {
            let product_id = event.row.product_id
            let payload = {product_id:product_id}
            await axios.post(apiRoutes['INVENTORY_RETRIEVE_PRODUCT_SCHEDULES'],payload, authHeader()).then((response)=>
            {
                if (response.data.code == 1)
                {
                    this.schedules = response.data.data;
                    this.schedules.product_code = event.row.product_code
                    
                    if (this.schedules.gits.length > 0 || this.schedules.reserved.length > 0)
                        this.rowDetailsModal = true

                }
                else
                {
                    this.schedules = [];
                }
            }
            )
            .catch((error)=> {
            if(error.response)
            {
                Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
            }
            });
       }
    }
  },
  mounted()
  {
      //this.updateTableLang()
  }
}
</script>
<style>
    th.VueTables__sortable {
        color:rgb(255,255,255);
    }
    td.VueTables__row  {
        color:black
    }
    .v-data-table /deep/ .sticky-header {
      position: sticky;
      top: var(--toolbarHeight);
    }

    .v-data-table /deep/ .v-data-table__wrapper {
      overflow: unset;
    }
  </style>

